// package: item.base
// file: item/base/model.proto

import * as common_enum_value_options from "../../common/enum_value_options";
import * as common_shop_type from "../../common/shop_type";
import * as common_source_type from "../../common/source_type";

export const CouponInfo = {
    encode(object) {
        const message = {};
        if (object.info != null) {
            if (object.info !== "") {
                message.info = String(object.info);
            }
        }
        if (object.startTime != null) {
            if (object.startTime !== 0) {
                message.startTime = object.startTime | 0;
            }
        }
        if (object.endTime != null) {
            if (object.endTime !== 0) {
                message.endTime = object.endTime | 0;
            }
        }
        if (object.price != null) {
            if (object.price !== 0) {
                message.price = object.price | 0;
            }
        }
        if (object.totalCount != null) {
            if (object.totalCount !== 0) {
                message.totalCount = object.totalCount | 0;
            }
        }
        if (object.remainCount != null) {
            if (object.remainCount !== 0) {
                message.remainCount = object.remainCount | 0;
            }
        }
        if (object.link != null) {
            if (object.link !== "") {
                message.link = String(object.link);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            info: "",
            startTime: 0,
            endTime: 0,
            price: 0,
            totalCount: 0,
            remainCount: 0,
            link: "",
        };

        if (message.info != null) {
            object.info = message.info;
        }
        if (message.startTime != null) {
            object.startTime = message.startTime;
        }
        if (message.endTime != null) {
            object.endTime = message.endTime;
        }
        if (message.price != null) {
            object.price = message.price;
        }
        if (message.totalCount != null) {
            object.totalCount = message.totalCount;
        }
        if (message.remainCount != null) {
            object.remainCount = message.remainCount;
        }
        if (message.link != null) {
            object.link = message.link;
        }
        return object;
    },
};

export const BrandInfo = {
    encode(object) {
        const message = {};
        if (object.name != null) {
            if (object.name !== "") {
                message.name = String(object.name);
            }
        }
        if (object.logo != null) {
            if (object.logo !== "") {
                message.logo = String(object.logo);
            }
        }
        if (object.platformBrandID != null) {
            if (object.platformBrandID !== "") {
                message.platformBrandID = String(object.platformBrandID);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            name: "",
            logo: "",
            platformBrandID: "",
        };

        if (message.name != null) {
            object.name = message.name;
        }
        if (message.logo != null) {
            object.logo = message.logo;
        }
        if (message.platformBrandID != null) {
            object.platformBrandID = message.platformBrandID;
        }
        return object;
    },
};

export const ItemBase = {
    encode(object) {
        const message = {};
        if (object.ID != null) {
            if (object.ID !== "") {
                message.ID = String(object.ID);
            }
        }
        if (object.sourceType != null) {
            if (object.sourceType !== 0) {
                message.sourceType = object.sourceType;
            }
        }
        if (object.sourceIID != null) {
            if (object.sourceIID !== "") {
                message.sourceIID = String(object.sourceIID);
            }
        }
        if (object.title != null) {
            if (object.title !== "") {
                message.title = String(object.title);
            }
        }
        if (object.shortTitle != null) {
            if (object.shortTitle !== "") {
                message.shortTitle = String(object.shortTitle);
            }
        }
        if (object.hotTitle != null) {
            if (object.hotTitle !== "") {
                message.hotTitle = String(object.hotTitle);
            }
        }
        if (object.brandName != null) {
            if (object.brandName !== "") {
                message.brandName = String(object.brandName);
            }
        }
        if (object.brandLogo != null) {
            if (object.brandLogo !== "") {
                message.brandLogo = String(object.brandLogo);
            }
        }
        if (object.imageURL != null) {
            if (object.imageURL !== "") {
                message.imageURL = String(object.imageURL);
            }
        }
        if (object.smallImages != null) {
            if (!Array.isArray(object.smallImages)) {
                throw TypeError("smallImages: array expected");
            }
            if (object.smallImages.length > 0) {
                message.smallImages = [];
                for (let i = 0; i < object.smallImages.length; ++i) {
                    message.smallImages[i] = String(object.smallImages[i]);
                }
            }
        }
        if (object.videoURL != null) {
            if (object.videoURL !== "") {
                message.videoURL = String(object.videoURL);
            }
        }
        if (object.price != null) {
            if (object.price !== 0) {
                message.price = object.price | 0;
            }
        }
        if (object.finalPrice != null) {
            if (object.finalPrice !== 0) {
                message.finalPrice = object.finalPrice | 0;
            }
        }
        if (object.shopName != null) {
            if (object.shopName !== "") {
                message.shopName = String(object.shopName);
            }
        }
        if (object.shopType != null) {
            if (object.shopType !== 0) {
                message.shopType = object.shopType;
            }
        }
        if (object.volume != null) {
            if (object.volume !== 0) {
                message.volume = object.volume | 0;
            }
        }
        if (object.coupon != null) {
            message.coupon = CouponInfo.encode(object.coupon);
        }
        if (object.status != null) {
            if (object.status !== 0) {
                message.status = object.status;
            }
        }
        if (object.itemTag != null) {
            if (object.itemTag !== "") {
                message.itemTag = String(object.itemTag);
            }
        }
        if (object.presale != null) {
            message.presale = PresaleInfo.encode(object.presale);
        }
        if (object.updatedTime != null) {
            if (object.updatedTime !== 0) {
                message.updatedTime = String(object.updatedTime);
            }
        }
        if (object.pinduoduoGoodsSign != null) {
            if (object.pinduoduoGoodsSign !== "") {
                message.pinduoduoGoodsSign = String(object.pinduoduoGoodsSign);
            }
        }
        if (object.sourceRewardAmount != null) {
            if (object.sourceRewardAmount !== 0) {
                message.sourceRewardAmount = String(object.sourceRewardAmount);
            }
        }
        if (object.goodsSign != null) {
            if (object.goodsSign !== "") {
                message.goodsSign = String(object.goodsSign);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            ID: "",
            sourceType: 0,
            sourceIID: "",
            title: "",
            shortTitle: "",
            hotTitle: "",
            brandName: "",
            brandLogo: "",
            imageURL: "",
            smallImages: [],
            videoURL: "",
            price: 0,
            finalPrice: 0,
            shopName: "",
            shopType: 0,
            volume: 0,
            coupon: null,
            status: 0,
            itemTag: "",
            presale: null,
            updatedTime: 0,
            pinduoduoGoodsSign: "",
            sourceRewardAmount: 0,
            goodsSign: "",
        };

        if (message.ID != null) {
            object.ID = message.ID;
        }
        if (message.sourceType != null) {
            object.sourceType = message.sourceType;
        }
        if (message.sourceIID != null) {
            object.sourceIID = message.sourceIID;
        }
        if (message.title != null) {
            object.title = message.title;
        }
        if (message.shortTitle != null) {
            object.shortTitle = message.shortTitle;
        }
        if (message.hotTitle != null) {
            object.hotTitle = message.hotTitle;
        }
        if (message.brandName != null) {
            object.brandName = message.brandName;
        }
        if (message.brandLogo != null) {
            object.brandLogo = message.brandLogo;
        }
        if (message.imageURL != null) {
            object.imageURL = message.imageURL;
        }
        if (message.smallImages != null) {
            object.smallImages = [];
            for (let i = 0; i < message.smallImages.length; ++i) {
                    object.smallImages[i] = message.smallImages[i];
            }
        }
        if (message.videoURL != null) {
            object.videoURL = message.videoURL;
        }
        if (message.price != null) {
            object.price = message.price;
        }
        if (message.finalPrice != null) {
            object.finalPrice = message.finalPrice;
        }
        if (message.shopName != null) {
            object.shopName = message.shopName;
        }
        if (message.shopType != null) {
            object.shopType = message.shopType;
        }
        if (message.volume != null) {
            object.volume = message.volume;
        }
        if (message.coupon != null) {
            object.coupon = CouponInfo.decode(message.coupon);
        }
        if (message.status != null) {
            object.status = message.status;
        }
        if (message.itemTag != null) {
            object.itemTag = message.itemTag;
        }
        if (message.presale != null) {
            object.presale = PresaleInfo.decode(message.presale);
        }
        if (message.updatedTime != null) {
            object.updatedTime = parseInt(message.updatedTime, 10);
        }
        if (message.pinduoduoGoodsSign != null) {
            object.pinduoduoGoodsSign = message.pinduoduoGoodsSign;
        }
        if (message.sourceRewardAmount != null) {
            object.sourceRewardAmount = parseInt(message.sourceRewardAmount, 10);
        }
        if (message.goodsSign != null) {
            object.goodsSign = message.goodsSign;
        }
        return object;
    },
};

export const PresaleInfo = {
    encode(object) {
        const message = {};
        if (object.info != null) {
            if (object.info !== "") {
                message.info = String(object.info);
            }
        }
        if (object.deposit != null) {
            if (object.deposit !== 0) {
                message.deposit = String(object.deposit);
            }
        }
        if (object.discount != null) {
            if (object.discount !== 0) {
                message.discount = String(object.discount);
            }
        }
        if (object.startTime != null) {
            if (object.startTime !== 0) {
                message.startTime = String(object.startTime);
            }
        }
        if (object.endTime != null) {
            if (object.endTime !== 0) {
                message.endTime = String(object.endTime);
            }
        }
        if (object.tailStartTime != null) {
            if (object.tailStartTime !== 0) {
                message.tailStartTime = String(object.tailStartTime);
            }
        }
        if (object.tailEndTime != null) {
            if (object.tailEndTime !== 0) {
                message.tailEndTime = String(object.tailEndTime);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            info: "",
            deposit: 0,
            discount: 0,
            startTime: 0,
            endTime: 0,
            tailStartTime: 0,
            tailEndTime: 0,
        };

        if (message.info != null) {
            object.info = message.info;
        }
        if (message.deposit != null) {
            object.deposit = parseInt(message.deposit, 10);
        }
        if (message.discount != null) {
            object.discount = parseInt(message.discount, 10);
        }
        if (message.startTime != null) {
            object.startTime = parseInt(message.startTime, 10);
        }
        if (message.endTime != null) {
            object.endTime = parseInt(message.endTime, 10);
        }
        if (message.tailStartTime != null) {
            object.tailStartTime = parseInt(message.tailStartTime, 10);
        }
        if (message.tailEndTime != null) {
            object.tailEndTime = parseInt(message.tailEndTime, 10);
        }
        return object;
    },
};

export const PriceInfo = {
    encode(object) {
        const message = {};
        if (object.usedCouponPrice != null) {
            if (object.usedCouponPrice !== 0) {
                message.usedCouponPrice = String(object.usedCouponPrice);
            }
        }
        if (object.finalPrice != null) {
            if (object.finalPrice !== 0) {
                message.finalPrice = String(object.finalPrice);
            }
        }
        if (object.couponPrice != null) {
            if (object.couponPrice !== 0) {
                message.couponPrice = String(object.couponPrice);
            }
        }
        if (object.commission != null) {
            if (object.commission !== 0) {
                message.commission = String(object.commission);
            }
        }
        if (object.commissionRate != null) {
            if (object.commissionRate !== 0) {
                message.commissionRate = String(object.commissionRate);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            usedCouponPrice: 0,
            finalPrice: 0,
            couponPrice: 0,
            commission: 0,
            commissionRate: 0,
        };

        if (message.usedCouponPrice != null) {
            object.usedCouponPrice = parseInt(message.usedCouponPrice, 10);
        }
        if (message.finalPrice != null) {
            object.finalPrice = parseInt(message.finalPrice, 10);
        }
        if (message.couponPrice != null) {
            object.couponPrice = parseInt(message.couponPrice, 10);
        }
        if (message.commission != null) {
            object.commission = parseInt(message.commission, 10);
        }
        if (message.commissionRate != null) {
            object.commissionRate = parseInt(message.commissionRate, 10);
        }
        return object;
    },
};

export const ItemSpec = {
    encode(object) {
        const message = {};
        if (object.SpecName != null) {
            if (object.SpecName !== "") {
                message.SpecName = String(object.SpecName);
            }
        }
        if (object.SpecValue != null) {
            if (object.SpecValue !== "") {
                message.SpecValue = String(object.SpecValue);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            SpecName: "",
            SpecValue: "",
        };

        if (message.SpecName != null) {
            object.SpecName = message.SpecName;
        }
        if (message.SpecValue != null) {
            object.SpecValue = message.SpecValue;
        }
        return object;
    },
};

export const ItemSpecV2 = {
    encode(object) {
        const message = {};
        if (object.name != null) {
            if (object.name !== "") {
                message.name = String(object.name);
            }
        }
        if (object.value != null) {
            if (object.value !== "") {
                message.value = String(object.value);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            name: "",
            value: "",
        };

        if (message.name != null) {
            object.name = message.name;
        }
        if (message.value != null) {
            object.value = message.value;
        }
        return object;
    },
};

export const SPU = {
    encode(object) {
        const message = {};
        if (object.ID != null) {
            if (object.ID !== "") {
                message.ID = String(object.ID);
            }
        }
        if (object.title != null) {
            if (object.title !== "") {
                message.title = String(object.title);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            ID: "",
            title: "",
        };

        if (message.ID != null) {
            object.ID = message.ID;
        }
        if (message.title != null) {
            object.title = message.title;
        }
        return object;
    },
};

export const SPUV2 = {
    encode(object) {
        const message = {};
        if (object.ID != null) {
            if (object.ID !== "") {
                message.ID = String(object.ID);
            }
        }
        if (object.title != null) {
            if (object.title !== "") {
                message.title = String(object.title);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            ID: "",
            title: "",
        };

        if (message.ID != null) {
            object.ID = message.ID;
        }
        if (message.title != null) {
            object.title = message.title;
        }
        return object;
    },
};

export const Range = {
    encode(object) {
        const message = {};
        if (object.begin != null) {
            if (object.begin !== 0) {
                message.begin = String(object.begin);
            }
        }
        if (object.end != null) {
            if (object.end !== 0) {
                message.end = String(object.end);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            begin: 0,
            end: 0,
        };

        if (message.begin != null) {
            object.begin = parseInt(message.begin, 10);
        }
        if (message.end != null) {
            object.end = parseInt(message.end, 10);
        }
        return object;
    },
};


export const FeatureType = {
    FEATURE_TYPE_UNDEFINED: 0,
    FEATURE_TYPE_LOWEST_PRICE_30DAY: 1,
    FEATURE_TYPE_LOWEST_PRICE_15DAY: 2,
    FEATURE_TYPE_LOWEST_PRICE_7DAY: 3,
    FEATURE_TYPE_DATAOKE_REAL_TIME_TOP_LIST: 4,
    FEATURE_TYPE_DATAOKE_TODAY_TOP_LIST: 5,
    FEATURE_TYPE_JUHUASUAN: 6,
    FEATURE_TYPE_TAOQIANGGOU: 7,
    FEATURE_TYPE_TMALL_MARKET: 8,
    FEATURE_TYPE_BRAND: 9,
    FEATURE_TYPE_LOCKED_COMMISSION: 10,
    FEATURE_TYPE_HAS_FIRST_ORDER_GIFT: 11,
    FEATURE_TYPE_CHAOJIFAN: 12,
    FEATURE_TYPE_SHOUMANWU: 13,
    FEATURE_TYPE_HOT_ITEM: 14,
    FEATURE_TYPE_ZHIJIANG_ITEM: 15,
};


export const ItemStatus = {
    ITEM_STATUS_UNDEFINED: 0,
    ITEM_STATUS_ONLINE: 1,
    ITEM_STATUS_OFFLINE: 2,
    ITEM_STATUS_DELETED: 3,
    ITEM_STATUS_CONDITION_NOT_SATISFIED: 4,
    ITEM_STATUS_NOT_IN_PROMOTION: 5,
    ITEM_STATUS_IN_PROMOTION: 6,
};

export const ItemStatusDisplayName = {
    1 /* ITEM_STATUS_ONLINE */: "在线",
    2 /* ITEM_STATUS_OFFLINE */: "下架",
    3 /* ITEM_STATUS_DELETED */: "删除",
    4 /* ITEM_STATUS_CONDITION_NOT_SATISFIED */: "商品不满足入库条件",
    5 /* ITEM_STATUS_NOT_IN_PROMOTION */: "无促销活动",
    6 /* ITEM_STATUS_IN_PROMOTION */: "商品在营销库,无法跟单",
};

export const ItemRecommendStatus = {
    ITEM_RECOMMEND_STATUS_UNDEFINED: 0,
    ITEM_RECOMMEND_STATUS_ONLINE: 1,
    ITEM_RECOMMEND_STATUS_OFFLINE: 2,
};

export const ItemRecommendStatusDisplayName = {
    1 /* ITEM_RECOMMEND_STATUS_ONLINE */: "在线",
    2 /* ITEM_RECOMMEND_STATUS_OFFLINE */: "下架",
};

export const ForecastStatus = {
    FORECAST_STATUS_UNDEFINED: 0,
    FORECAST_STATUS_YES: 1,
    FORECAST_STATUS_NO: 2,
};

export const ForecastStatusDisplayName = {
    1 /* FORECAST_STATUS_YES */: "预告",
    2 /* FORECAST_STATUS_NO */: "非预告",
};

